// extracted by mini-css-extract-plugin
module.exports = {"st0":"MobileLogo_st0__YFRNB","st1":"MobileLogo_st1__3OZRo"};